import {
  GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2,
  GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_SUCCESS,
  GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_ERROR,
  GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_EMPTY,
} from '../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetDownloadDumpListCustomer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_DOWNLOAD_DUMP_ADMIN_CUSTOMER_V2_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetDownloadDumpListCustomer;
